import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CampaignModel } from 'src/app/models/CampaignModel';
import { CampaignTreeModel } from 'src/app/models/CampaignTreeModel';
import { RequestModel } from 'src/app/models/RequestModel';
import { TreesViewModel } from 'src/app/models/TreesViewModel';
import { locationCost } from 'src/app/shared/Calculations';

@Component({
    selector: 'app-step2',
    templateUrl: './step2.component.html',
    styleUrls: ['./step2.component.css']
})
export class Step2Component implements OnInit {
    get model(): TreesViewModel { return this._model; }
    @Input() set model(value: TreesViewModel) {
        this._model = value;
        this.campaign = value.campaign;
        this.request = value.request;
        if (value !== null) {
            this.initForm();
        }
        this.myTreesSelected = this.campaign.displayNotAvail.filter(t=>t.isSelected).length > 0;
    }
    request: RequestModel = null;
    campaign: CampaignModel = null;

    private _model: TreesViewModel = null;

    requestTreeForm: FormGroup = null;
    requestTreeForms: FormArray;
    notAvailableControl = new FormControl(null, [Validators.required]);
    notAvailableText = '';
    myTreesForm: FormArray = null;

    myTreesSelected=false;

    // campaign: CampaignModel;

    qtys = [0, 1, 2, 3];

    notAvails = [
        { num: 1, text: 'Any species available' },
        { num: 2, text: 'Only the species I have marked with a check below' },
        { num: 3, text: 'No other trees. Please cancel my application' }
    ];

    imageSource: any;

    constructor(private fb: FormBuilder,
        private sanitizer: DomSanitizer) {
        this.requestTreeForm = fb.group({
            requestTreeForms: fb.array([])
        });
        // this.requestTreeForms = <FormArray>this.requestTreeFormGroup.controls['requestTreeForms'];
        this.requestTreeForms = this.requestTreeForm.controls.requestTreeForms as FormArray;
    }

    ngOnInit(): void {
        // this.getRequestTrees();
    }

    private initForm(): void {
        for (const treeModel of this.campaign.trees) {
            this.requestTreeForms.push(this.initFormItem(treeModel));
        }
        if(!this.campaign.displayIfNotAvailable){
            this.notAvailableControl.clearValidators();
        }

        this.notAvailableControl
        .setValue(this.request.ifNotAvailableNum == 0 ? undefined : this.request.ifNotAvailableNum);

        this.myTreesForm = new FormArray([]);
        for (const tree of this.campaign.displayNotAvail) {
            this.myTreesForm.push(new FormControl(tree.isSelected));
        }

        this.myTreesForm.valueChanges.subscribe(v=>{
            this.myTreesSelected = v.indexOf(true) !== -1;
        });
        this.notAvailableControl.valueChanges.subscribe(value => {
            this.notAvailableText = this.notAvails[value - 1].text;
        });
    }

    getImage(index: number): SafeResourceUrl | null {
        if (this.campaign.trees[index].treeBase64Pic === null) {
            return null;
        }
        const imgsrc = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${this.campaign.trees[index].treeBase64Pic}`);
        return imgsrc;
    }

    getLocationCost(index: number, n: number): number {
        return locationCost(this.campaign.trees[index], n, this.request.neededTreeship,
            this.request.isTargetNeighborhood);
    }
    
    private initFormItem(model: CampaignTreeModel): FormGroup {
        return this.fb.group({
            qty1: [model.qty1],
            qty2: [model.qty2],
            qty3: [model.qty3],
            qty4: [model.qty4],
        });
    }

    anyOrdered(): boolean{
        let qty = 0;
        for (const t of this.requestTreeForms.value) {
            qty += t.qty1 + t.qty2 + t.qty3 + t.qty4;
        }
        return qty > 0;
    }
    saveRequest(): void {
        for (let i = 0; i < this.campaign.trees.length; i++) {
            this.updateModel(i);
        }

        this.request.ifNotAvailableNum = this.notAvailableControl.value || 0;
        this.request.notAvailableText = this.notAvailableText;
        for (let i = 0; i < this.campaign.displayNotAvail.length; i++) {
            this.campaign.displayNotAvail[i].isSelected = this.myTreesForm.value[i];
        }
    }

    private updateModel(index: number): void {
        const model = this.campaign.trees[index];
        const form = this.requestTreeForms.value[index];

        model.qty1 = form.qty1;
        model.qty2 = form.qty2;
        model.qty3 = form.qty3;
        model.qty4 = form.qty4;

        // form.markAsPristine();
        // form.markAsUntouched();
    }

    tree(i: number): CampaignTreeModel {
        return this.campaign.trees[i];
    }

    isValid(): boolean {
        let wantsValid = this.notAvailableControl.value === 2 && this.myTreesSelected || this.notAvailableControl.value !== 2;

        return this.notAvailableControl.valid && wantsValid && this.anyOrdered();
    }
    // private addLine(): RequestTreeModel {
    //     const model = new RequestTreeModel();
    //     this.requestTree.list.push(model);
    //     this.requestTreeForms.push(this.initFormItem(model));
    //     return model;
    // }

}
